export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/1.jpg'),
        title: '企业战略与转型',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '提高工作效率，降低运营成本',
      description: `<p style="font-size:1.05rem">业务转型是一种管理战略，意味着战略变革，旨在使组织及其中的个人更紧密地与公司的业务战略和愿景保持一致。 这一变化是任何现代化计划的重要组成部分，也是在竞争日益激烈的全球市场中生存所必需的。
在当今不断变化的全球经济中，许多公司改变其业务模式，以实现增长，保持竞争力并满足客户需求。 这种转变可能是外部因素的结果，您需要有经验的合作伙伴来帮助您实现业务战略和愿景。
​​MaesInfo拥有丰富的经验，可帮助客户制定并实施成功的业务战略和转型。 许多公司向我们寻求战略方向并帮助实现其企业愿景。
我们拥有专业知识，愿景和解决问题的技术，可帮助您有效地实施和执行您的战略和转型。
</p>`
    },
    {
      title: 'MaesInfo如何帮助您的业务:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/2.jpg')+`)"></span>
      <span class="list">
      <i></i>分析您的产品和市场的目标充分利用 <br/>
      <i></i>贵公司的市场机会<br/>
      <i></i>企业规划<br/>
      <i></i>业务部门战略<br/>
      <i></i>组合策略<br/>
      <i></i>增长战略<br/>
      <i></i>创新，多样化和商业化<br/>
      <i></i>临床研究策略<br/>
      <i></i>无机增长战略<br/>
      <i></i>无机增长战略<br/>
      <i></i>相互作用
      </span>`
    }
  ]
}
